export const environment = {
  production: false,
  backendEndpoint: 'https://app-stg.tracks.macnica.co.jp/api',
  versionNo: '2.1.0',
  amplify: {
    Auth: {
      Cognito: {
        userPoolId: 'us-west-2_y8uhR6N5d',
        userPoolClientId: 'nfrme23qrpl95v0cievucr55k',
        identityPoolId: 'us-west-2:3184c218-76d0-4016-a732-293a1722542a',
      },
    },
    Geo: {
      LocationService: {
        maps: {
          items: {
            'matp-staging-map': {
              style: 'VectorHereExplore',
            },
          },
          default: 'matp-staging-map',
        },
        region: 'us-west-2',
      },
    },
  },
};
